import { Component, OnInit, OnChanges, OnDestroy, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors, FormArray } from '@angular/forms';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule, Rating } from 'primeng/primeng';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { Message, FileUpload } from 'primeng/primeng';
import { UploadFilesService } from '../../../service/upload-files/upload-files.service';
import { config } from '../../../../../../environments/config';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { formatDate } from '../../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../../theme/functions/calendarES';

import { SystemsRequest } from '../../../class/systems-request';
import { SystemRequestService } from '../../../service/system-request/system-request.service';
import { SystemRequestTypesService } from '../../../service/system-request-types/system-request-types.service';
import { SystemRequestTypificationsService } from '../../../service/system-request-typifications/system-request-typifications.service';

@Component({
  selector: "app-new-system-request",
  templateUrl: "./new-system-request.component.html",
  styleUrls: ["./new-system-request.component.scss"],
})
export class NewSystemRequestComponent implements OnInit {
  @Output() msg: EventEmitter<object> = new EventEmitter<object>();
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() subPagePath: string;

  public msgs: Message[] = [];
  public promiseRequestForm: Promise<any>;
  public es: any;
  public LocationOptions: any[];

  private id: number;

  public typeRequestOptions: any[];
  public typificationRequestOptions: any[];

  public contactOptions: any[];
  public statusOptions: any[];

  public reasonCalificationOptions: any[];

  public doRequest: number = 0;
  public edit: SystemsRequest;

  public request_form: FormGroup;
  public editForm: any[] = [];

  public save_exit: boolean;
  public visible: boolean;

  public requestTypifications: any;

  public department_id: number = null;
  public venue_id: number = null;
  public calificated_by_id: any = null;

  public loading: boolean = false;

  public created_by_id: any = null;
  public employee_id: number = null;
  public systemsPosition: string = "47,76,77,78";
  public uploadedFileObservations: any[] = [];
  public prewiewFileObservations: any;
  public promiseFileObservations: Promise<any>;
  public apiUrl = config.API_ROOT;

  constructor(
    public fb: FormBuilder,
    public translate: TranslateService,
    private ngZone: NgZone,
    private notificationsService: NotificationsService,
    private mapsAPILoader: MapsAPILoader,
    public uploadFilesService: UploadFilesService,
    public hasPermissionService: HasPermissionService,
    private router: Router,
    private route: ActivatedRoute,
    public systemRequestService: SystemRequestService,
    public systemRequestTypesService: SystemRequestTypesService,
    public systemRequestTypificationsService: SystemRequestTypificationsService
  ) {
    this.es = calendarES();

    this.LocationOptions = [
      { label: "Casa", value: "Casa" },
      { label: "Cliente", value: "Cliente" },
      { label: "Redes Humanas", value: "Redes Humanas" },
    ];

    this.typeRequestOptions = this.getSystemRequestTypes();

    this.contactOptions = [
      { label: "Empresa", value: "Empresa" },
      { label: "Teléfono", value: "Teléfono" },
    ];

    this.statusOptions = [
      { label: "Abierto", value: "Abierto", disabled: true },
      { label: "En trámite", value: "En trámite", disabled: false },
      { label: "Escalado", value: "Escalado", disabled: false },
      { label: "Cerrado", value: "Cerrado", disabled: false },
      { label: "Calificado", value: "Calificado", disabled: true },
    ];
  }

  ngOnInit() {
    this.id = +this.route.snapshot.paramMap.get("id");

    this.employee_id = JSON.parse(localStorage.getItem("profile")).employee_id;

    if (this.id !== 0 && this.id !== undefined) {
      var promiseLoc = this.systemRequestService
        .infoSystemsRequest(this.id)
        .toPromise()
        .then(
          (response) => {
            this.edit = response.json();
            this.created_by_id = this.edit.created_by_id;
            this.getReasonCalificationMenu(this.edit.calification);
            this.getSystemRequestTypifications(
              this.edit.type_request_id,
              this.edit.typification_id
            );
            this.createNewRequestForm(this.edit);
            this.listFieldsFormsArray(
              this.system_request_answers,
              this.edit.system_request_answers,
              "system_request_answers"
            );
            this.listDocumentsFormsArray(
              this.documents_system_request,
              this.edit.documents_system_request
            );
            this.doRequest = 1;
            this.request_form.get("reason_calification").setValue("");

            this.request_form.get("mobile").disable();
            this.request_form.get("observations").disable();

            if (
              this.edit.reason_calification != null &&
              this.edit.reason_calification != "" &&
              this.edit.reason_calification != undefined
            )
              this.request_form
                .get("reason_calification")
                .setValue(this.edit.reason_calification);
            this.putMoreRequiredFields();
          },
          (error) => {
            this.notificationsService.growlNotify(
              "error",
              "ID " + this.id + " no encontrado"
            );
            this.router.navigateByUrl("/pages/innovation/systems-requests");
          }
        );
    } else {
      this.created_by_id = this.employee_id;
      this.createNewRequestForm();
      this.doRequest = 1;
    }
  }

  createNewRequestForm(data: any = null) {
    data = data || {
      id: undefined,
      status: "Abierto",
      date_request: null,
      date_close: null,

      created_by_id: null,
      venue_id: "",
      department_id: "",

      location: "",
      type_request_id: "",
      typification_id: "",
      maximum_time: "",
      criticality: "",
      contact_medium: "",
      mobile: "",
      observations: "",

      calificated_by_id: null,
      calification: 0,
      reason_calification: "",
      date_calification: "",
      observations_calification: "",
    };

    this.request_form = this.fb.group({
      id: [data.id],
      status: [
        {
          value: data.status,
          disabled:
            data.status === "Cerrado" ||
            data.status === "Calificado" ||
            !this.hasPermission("edit system request"),
        },
      ],
      date_request: [
        {
          value: data.date_request ? new Date(data.date_request) : null,
          disabled: true,
        },
      ],
      date_close: [
        {
          value: data.date_close ? new Date(data.date_close) : null,
          disabled: true,
        },
      ],

      created_by_id: [data.created_by_id, []],
      venue_id: [data.venue_id],
      department_id: [data.department_id],

      location: [data.location, [Validators.required, Validators.minLength(1)]],
      type_request_id: [
        { value: data.type_request_id, disabled: !this.edit ? false : true },
        [Validators.required, Validators.minLength(1)],
      ],
      typification_id: [
        { value: data.typification_id, disabled: !this.edit ? false : true },
        [Validators.required, Validators.minLength(1)],
      ],
      maximum_time: [{ value: data.maximum_time, disabled: true }],
      criticality: [{ value: data.criticality, disabled: true }],
      contact_medium: [
        data.contact_medium,
        [Validators.required, Validators.minLength(1)],
      ],
      mobile: [
        data.mobile,
        [
          Validators.required,
          Validators.pattern(/^3\d{9}$/),
          Validators.minLength(7),
          Validators.maxLength(10),
        ],
      ],
      observations: [
        data.observations,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(500),
        ],
      ],

      calificated_by_id: [{ value: data.calificated_by_id, disabled: true }],
      calification: [data.calification],
      reason_calification: [data.reason_calification],
      date_calification: [
        {
          value: data.date_calification
            ? new Date(data.date_calification)
            : null,
          disabled: true,
        },
      ],
      observations_calification: [
        {
          value: data.observations_calification,
          disabled:
            !this.isTheSameEmployee() ||
            this.statusEditCalification("Calificado")
              ? true
              : false,
        },
      ],

      system_request_answers: this.fb.array([]),
      documents_system_request: this.fb.array([]),
    });
  }

  addAnswer(data: any = null) {
    data = data || {
      id: undefined,
      date_answer: null,
      worked_by_id: null,
      observations_answer: "",
    };

    const answerForm = this.fb.group({
      id: [data.id],
      date_answer: [
        {
          value: data.date_answer ? new Date(data.date_answer) : null,
          disabled: true,
        },
      ],
      worked_by_id: [data.worked_by_id, [Validators.required]],
      observations_answer: [
        {
          value: data.observations_answer,
          disabled:
            data.observations_answer ||
            (!this.hasPermission("edit system request") ? true : false),
        },
        [Validators.required, Validators.maxLength(300)],
      ],
    });

    this.editForm.push(data);

    this.system_request_answers.push(answerForm);

    return;
  }

  get documents_system_request(): FormArray {
    return this.request_form.get("documents_system_request") as FormArray;
  }

  addFile(data: any = null, fileContent: any = null) {
    data = data || {
      id: undefined,
      attachment: fileContent ? fileContent.name : null,
      file: fileContent,
    };

    const fileForm = this.fb.group({
      id: [data.id],
      attachment: [data.attachment],
      file: data.file, // El archivo real no se cargará aquí
    });

    return fileForm;
  }

  public gotoDocument(id) {
      window.open(this.apiUrl + '/systems-request/' + id + '/attachment' + '?token=' + localStorage.getItem('token'), '_blank');
  }

  removeDocument(index: number) {
    // Eliminar el FormGroup en la posición `index` del FormArray `documents_system_request`
    if (index >= 0 && index < this.documents_system_request.length) {
      this.documents_system_request.removeAt(index);
    }
  }

  listDocumentsFormsArray(formArrayLoc: FormArray, data: any[]) {
    this.clearFormArray(formArrayLoc);

    if (data != undefined && data.length > 0) {
      data.forEach((file) => {
        this.documents_system_request.push(this.addFile(file));
      });
    }
  }

  onDocumentsSystemRequestChange(event: any) {
    const selectedDocuments = Array.from(event.target.files);
    selectedDocuments.forEach((fileContent) => {
      this.documents_system_request.push(this.addFile(null, fileContent));
    });
  }

  addDocumentsForm(event: any) {
    this.documents_system_request.push(this.addFile());
  }

  public newSystemsRequests(values) {
    values.id = values.id == null ? undefined : values.id;

    if (values.created_by_id) {
      if (values.created_by_id.id)
        values.created_by_id = values.created_by_id.id;
      else values.created_by_id = values.created_by_id;
    } else values.created_by_id = this.edit.created_by_id;

    values.mobile = values.mobile ? values.mobile : this.edit.mobile;
    values.observations = values.observations
      ? values.observations
      : this.edit.observations;

    if (values.id == null || values.id == "" || values.id == undefined) {
      values.status = "Abierto";
    } else {
      if (values.status) values.status = values.status;
      else values.status = this.edit.status;
    }
    // values.status = (values.status) ? values.status : this.edit.status;

    if (this.edit) {
      if (this.edit.date_request)
        values.date_request = formatDate(this.edit.date_request);
      else values.date_request = formatDate(new Date());
    } else values.date_request = formatDate(new Date());

    values.type_request_id = values.type_request_id
      ? values.type_request_id
      : this.edit.type_request_id;
    values.typification_id = values.typification_id
      ? values.typification_id
      : this.edit.typification_id;

    var param = {
      id: values.id,
      status: values.status,
      date_request: values.date_request,
      created_by_id: values.created_by_id,
      location: values.location,
      type_request_id: values.type_request_id,
      typification_id: values.typification_id,
      contact_medium: values.contact_medium,
      mobile: values.mobile,
      observations: values.observations,
    };

    if (
      values.status == "En trámite" ||
      values.status == "Escalado" ||
      values.status == "Cerrado"
    ) {
      if (values.system_request_answers) {
        for (let i = 0; i < values.system_request_answers.length; i++) {
          values.system_request_answers[i].id =
            values.system_request_answers[i].id == null
              ? undefined
              : values.system_request_answers[i].id;

          values.system_request_answers[i].worked_by_id =
            values.system_request_answers[i].worked_by_id.id;
          values.system_request_answers[i].observations_answer = values
            .system_request_answers[i].observations_answer
            ? values.system_request_answers[i].observations_answer
            : this.edit.system_request_answers[i].observations_answer;

          if (this.edit) {
            if (
              this.edit.system_request_answers.length > 0 &&
              this.edit.system_request_answers[i]
            ) {
              if (
                this.edit.system_request_answers[i].date_answer != null &&
                this.edit.system_request_answers[i].date_answer != undefined
              )
                values.system_request_answers[i].date_answer =
                  this.edit.system_request_answers[i].date_answer;
              else
                values.system_request_answers[i].date_answer = formatDate(
                  new Date()
                );
            } else
              values.system_request_answers[i].date_answer = formatDate(
                new Date()
              );
          } else
            values.system_request_answers[i].date_answer = formatDate(
              new Date()
            );
        }

        param["system_request_answers"] = values.system_request_answers;
      }

      if (values.status == "Cerrado") {
        if (this.edit) {
          if (this.edit.date_close)
            values.date_close = formatDate(this.edit.date_close);
          else values.date_close = formatDate(new Date());
        } else values.date_close = formatDate(new Date());

        param["date_close"] = values.date_close;
      }
    }

    if (this.edit && this.employee_id == values.created_by_id) {
      if (this.edit.status == "Cerrado") {
        if (values.calification != 0) {
          values.calificated_by_id = values.created_by_id;

          if (this.edit.date_calification)
            values.date_calification = formatDate(this.edit.date_calification);
          else values.date_calification = formatDate(new Date());

          param["date_calification"] = values.date_calification;
          param["calification"] = values.calification;
          param["calificated_by_id"] = values.calificated_by_id;
          param["reason_calification"] = values.reason_calification;
          param["observations_calification"] = values.observations_calification;
          param.status = "Calificado";
        }
      }
    }
    const formData = this.buildFormData(values.documents_system_request, param);
    if (param && this.request_form.valid) {
      this.loading = true;
      const promise = this.edit
        ? this.systemRequestService.updateSystemsRequest(this.edit.id, formData)
        : this.systemRequestService.newSystemsRequest(formData);
      this.promiseRequestForm = promise.toPromise().then(
        (response) => {
          this.translate.get("saved").subscribe((res: string) => {
            this.notificationsService.growlNotify("success", res);
            this.edit = response.json();
            // this.msg.emit( { severity: 'success', summary: res  } );
            this.close.emit(true);
            this.request_form.reset();
          });
          this.router.navigateByUrl("/pages/innovation/systems-requests");
        },
        (error) => {
          this.loading = false;
          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg
                  );
                  // this.msg.emit( { severity: 'error', summary: 'Error' } );
                });
            });
        }
      );
    }
  }

  public cancelSystemsRequest(values) {
    this.request_form.reset();
    this.close.emit(true);
    this.router.navigateByUrl("/pages/innovation/systems-requests");
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

  public hasRole(rol) {
    var r: boolean = false;
    var role = JSON.parse(localStorage.getItem("profile")).roles[0].id;
    if (role == rol) r = true;

    return r;
  }

  listFieldsFormsArray(
    formArrayLoc: FormArray,
    data: any[],
    execfunction: string
  ) {
    this.clearFormArray(formArrayLoc);

    if (data.length > 0) {
      data.forEach((element) => {
        this.addAnswer(element);
      });
    }
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  };

  get system_request_answers() {
    return this.request_form.controls["system_request_answers"] as FormArray;
  }

  // deleteAnswer(systemRequestAnswerIndex: number) {
  //   this.system_request_answers.removeAt(systemRequestAnswerIndex);
  // }

  getSystemRequestTypes(query?: string, filters?: any[]) {
    let page = 1;
    let per_page = 10;
    let sort = "id";

    let typeOptions = [];

    this.systemRequestTypesService
      .getTypes(page, per_page, sort, query, filters)
      .toPromise()
      .then(
        (response) => {
          var requestTypes = response.json().data;
          for (let i = 0; i < requestTypes.length; i++)
            typeOptions.push({
              id: requestTypes[i].id,
              label: requestTypes[i].type,
              value: requestTypes[i].type,
            });
        },
        (error) => {
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "error" });
          typeOptions.push({ id: "", label: "Error", value: "Error" });
        }
      );
    return typeOptions;
  }

  onTypeRequestChange(event) {
    const selectedTypeRequestId = event.target.value;
    this.request_form.get("typification_id").setValue("");
    this.request_form.get("maximum_time").setValue("");
    this.request_form.get("criticality").setValue("");
    this.getSystemRequestTypifications(selectedTypeRequestId);
  }

  getSystemRequestTypifications(
    selectedTypeRequestId: string,
    selected_typification_id?: string,
    query?: string
  ) {
    let page = 1;
    let per_page = 100;
    let sort = "id";
    let filters = [];
    filters.push({
      key: "system_request_type_id",
      value: selectedTypeRequestId,
    });

    let typificationsOptions = [];

    this.systemRequestTypificationsService
      .getTypifications(page, per_page, sort, query, filters)
      .toPromise()
      .then(
        (response) => {
          this.requestTypifications = response.json().data;
          for (let i = 0; i < this.requestTypifications.length; i++) {
            if (this.requestTypifications[i].id == selected_typification_id) {
              typificationsOptions.push({
                id: this.requestTypifications[i].id,
                label: this.requestTypifications[i].description,
                value: this.requestTypifications[i].description,
                selected: true,
              });
              this.request_form
                .get("typification_id")
                .setValue(this.requestTypifications[i].id);
              this.request_form
                .get("maximum_time")
                .setValue(this.requestTypifications[i].response_time);
              this.request_form
                .get("criticality")
                .setValue(this.requestTypifications[i].criticality);
            } else
              typificationsOptions.push({
                id: this.requestTypifications[i].id,
                label: this.requestTypifications[i].description,
                value: this.requestTypifications[i].description,
                selected: false,
              });
          }
        },
        (error) => {
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "error" });
          typificationsOptions.push({ id: "", label: "Error", value: "Error" });
        }
      );
    this.typificationRequestOptions = typificationsOptions;
  }

  onTypificationRequestChange(event) {
    const selectedTypificationId = event.target.value;

    let typification = this.getTypificationObject(selectedTypificationId);

    this.request_form.get("maximum_time").setValue(typification.response_time);
    this.request_form.get("criticality").setValue(typification.criticality);
  }

  public getTypificationObject(typification_request_id) {
    return this.requestTypifications.find(
      (typification) => typification.id == typification_request_id
    );
  }

  public uploadReasonCalificationMenu(starRating) {
    this.request_form.get("reason_calification").setValue("");

    this.getReasonCalificationMenu(starRating);
  }

  public getReasonCalificationMenu(rating) {
    this.reasonCalificationOptions = [];

    if (rating > 0 && rating <= 3) {
      this.reasonCalificationOptions.push({
        label: "No se respondió en el tiempo adecuado",
        value: "No se respondió en el tiempo adecuado",
      });
      this.reasonCalificationOptions.push({
        label: "Nunca se contactó con el Departamento",
        value: "Nunca se contactó con el Departamento",
      });
    } else if (rating > 3 && rating <= 5) {
      this.reasonCalificationOptions.push({
        label: "Respuesta rápida",
        value: "Respuesta rápida",
      });
      this.reasonCalificationOptions.push({
        label: "Excelente servicio",
        value: "Excelente servicio",
      });
      this.reasonCalificationOptions.push({
        label: "El colaborador mostró empatía",
        value: "El colaborador mostró empatía",
      });
      this.reasonCalificationOptions.push({
        label: "Se solucionó el requerimiento",
        value: "Se solucionó el requerimiento",
      });
    }
  }

  public uploadDataFromCreatedById(event) {
    this.request_form.get("department_id").setValue("");
    this.request_form.get("venue_id").setValue("");

    this.department_id = event.department_id;
    this.venue_id = event.venue_id;
    if (this.edit) this.calificated_by_id = this.edit.created_by_id;
  }

  public putMoreRequiredFields() {
    this.request_form
      .get("status")
      .setValidators([Validators.required, Validators.minLength(1)]);

    if (this.edit.status == "Cerrado") {
      this.request_form
        .get("calificated_by_id")
        .setValidators([Validators.required]);
      this.request_form
        .get("calification")
        .setValidators([Validators.required]);
      this.request_form
        .get("reason_calification")
        .setValidators([Validators.required, Validators.minLength(1)]);
      // this.request_form.get('observations_calification').setValidators([ Validators.required, Validators.minLength(2), Validators.maxLength(300) ]);
      this.request_form.get("observations_calification");
    }
  }

  public statusEditCalification(parameterRequest: string) {
    let status = false;
    if (this.edit) {
      if (this.edit.status == parameterRequest) status = true;
    }

    return status;
  }

  public isTheSameEmployee() {
    let status = false;
    if (this.edit) {
      if (this.edit.created_by_id == this.employee_id.toString()) status = true;
    }

    return status;
  }
  
  buildFormData(input_documents: any[], body: Object) {
    const formData: FormData = new FormData();
    Object.entries(body).forEach(([key, value]) => {
      if (key != "id" && key != "Documents" && key != "system_request_answers") formData.append(key, value);
    });

    input_documents.forEach((obj) => {
      if (obj.file == null)
        formData.append("existing_documents_system_request[]", obj.id);
      else formData.append("new_documents_system_request[]", obj.file);
    });
    if(body["system_request_answers"])
    {
      if(body["system_request_answers"].length > 0)
      {
        body["system_request_answers"].forEach((element,index) =>{
          formData.append("system_request_answers[]", JSON.stringify(element));
        });
      }
    }
    return formData;
  }
}




// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/systems-requests/new-system-request/new-system-request.component.ts